<template>
  <a v-if="show" id="hard-limit-counter" :class="classObject" data-testid="hard-limit-counter">
    <span class="label">
      <span class="free-label">FREE</span> UPLOADS:
    </span>
    <div class="drops-used">
      <span>
        {{ userDropsCount }}
      </span>
      <span class="slash">
        /
      </span>
      <span>
        {{ limit }}
      </span>
    </div>
    <b-tooltip
      target="hard-limit-counter"
      v-if="userDropsCount >= limit"
      trigger="hover focus"
      title="Upload limit reached. Upgrade to unlock."
    ></b-tooltip>
  </a>
</template>

<script>
import featureKey from "../../feature_key.macro";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      limit: (state) => state.features?.[featureKey("hard-limit-drops")] || -1,
      freeOrg: (state) => state.currentOrganization.attributes.free,
      userDropsCount: (state) => state.user?.attributes?.item_count || 0,
      overlapButton: (state) => state.features?.[featureKey("upgrade-button-dashboard-viewer")],
      currentUser: (state) => state.user,
    }),
    show: function() {
      return this.limit !== -1 && this.freeOrg;
    },
    classObject: function() {
      return {
        "limit-reached": this.userDropsCount >= this.limit,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "application.scss";

a {
  display: flex;
  flex-flow: row wrap;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: bold;
  font-family: SFPro;
  position: relative;
  align-items: center;
  .label {
    color: #828282;
    margin: 0 0.5rem 0 0;
  }

  .drops-used {
    color: $dark-gray;
  }
}


a.limit-reached {
  .drops-used {
    color: $grapefruit;
  }

  .slash {
    color: $dark-gray;
  }
}

a:hover {
  text-decoration: none;
  cursor: pointer;
}
@media screen and (max-width: 970px){
  .free-label{
    display:none;
  }
}
@media screen and (max-width: 410px){
  #sidebar-vue{
    .hard-limit-container{
      .limit-reached{
        display:none;
      }
    }
  }
}
</style>
